var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("minisite-header"),
      _c(
        "main",
        { staticClass: "container transfer-start" },
        [
          _c("div", { staticClass: "row transfer-start__page-title" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h3", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.say.transfer_start_page_title ||
                        "Przekaż swój start innej osobie"
                    ) +
                    " "
                ),
              ]),
            ]),
          ]),
          !_vm.ready
            ? [
                _vm._m(0),
                _vm._m(1),
                _c("p", { staticClass: "transfer-start__loading-text mat16" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.say.transfer_start_loading || "Ładowanie…") +
                      " "
                  ),
                ]),
              ]
            : _vm.errorMessage && !_vm.canTransfer
            ? [
                _c("div", { staticClass: "row transfer-start__section" }, [
                  _c("div", { staticClass: "col-12 col-lg-4" }, [
                    _c(
                      "div",
                      { staticClass: "transfer-start__section-header" },
                      [
                        _c("h3", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.say.transfer_start_error_title ||
                                  "Przekazanie startu"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "col-12 col-lg-8" }, [
                    _c(
                      "div",
                      { staticClass: "transfer-start__card bg--gray" },
                      [
                        _c("p", { staticClass: "transfer-start__error" }, [
                          _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "row transfer-start__section transfer-start__actions",
                  },
                  [
                    _c("div", {
                      staticClass: "col-12 col-lg-4 d-none d-lg-block",
                    }),
                    _c("div", { staticClass: "col-12 col-lg-8" }, [
                      _c(
                        "div",
                        { staticClass: "transfer-start__buttons" },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { btn2: "", short: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.goBack()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.say.transfer_start_btn_back || "Cofnij"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "base-button",
                            {
                              attrs: { btn1: "", short: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.goToCompetitions()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.say
                                      .transfer_start_btn_back_to_competitions ||
                                      "Wróć do zawodów"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            : _vm.rebateCode
            ? [
                _c("div", { staticClass: "row transfer-start__section" }, [
                  _c("div", { staticClass: "col-12 col-lg-4" }, [
                    _c(
                      "div",
                      { staticClass: "transfer-start__section-header" },
                      [
                        _c("h3", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.say.transfer_start_rules_title ||
                                  "Zasady przekazywania startu"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "col-12 col-lg-8" }, [
                    _c(
                      "div",
                      { staticClass: "transfer-start__card bg--gray" },
                      [
                        _c(
                          "h3",
                          { staticClass: "transfer-start__content-title" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.say.transfer_start_cannot_start_title ||
                                    "Nie możesz wystartować?"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("p", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.say.transfer_start_success_intro ||
                                  "Mail z linkiem do rejestracji został wysłany. Poniżej znajdziesz kod przekazania startu — udostępnij go zaproszonej osobie."
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "transfer-start__code mat24" },
                          [
                            _c(
                              "p",
                              { staticClass: "transfer-start__code-label" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.say.transfer_start_code_label ||
                                        "Kod przekazania startu"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "p",
                              { staticClass: "transfer-start__code-value" },
                              [_vm._v(_vm._s(_vm.rebateCode))]
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "mat16" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.say.transfer_start_success_followup ||
                                    "Zaproszona osoba rejestruje się z linku, wpisuje kod w polu kodu rabatowego"
                                ) +
                                " "
                            ),
                            _vm.isFree
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.say
                                          .transfer_start_success_outro_free ||
                                          " i bezpłatnie finalizuje przejęcie startu."
                                      ) +
                                      " "
                                  ),
                                ]
                              : [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.say
                                          .transfer_start_success_outro_paid ||
                                          " i opłaca online koszt przekazania."
                                      ) +
                                      " "
                                  ),
                                ],
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.say.transfer_start_success_settlement ||
                                    " Rozliczenie ewentualnego zwrotu opłaty startowej między Wami odbywa się poza systemem."
                                ) +
                                " "
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "row transfer-start__section transfer-start__actions",
                  },
                  [
                    _c("div", {
                      staticClass: "col-12 col-lg-4 d-none d-lg-block",
                    }),
                    _c("div", { staticClass: "col-12 col-lg-8" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "transfer-start__buttons transfer-start__buttons--end",
                        },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { btn1: "", short: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.goToCompetitions()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.say
                                      .transfer_start_btn_back_to_competitions ||
                                      "Wróć do zawodów"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            : [
                _c("div", { staticClass: "row transfer-start__section" }, [
                  _c("div", { staticClass: "col-12 col-lg-4" }, [
                    _c(
                      "div",
                      { staticClass: "transfer-start__section-header" },
                      [
                        _c("h3", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.say.transfer_start_rules_title ||
                                  "Zasady przekazywania startu"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "col-12 col-lg-8" }, [
                    _c(
                      "div",
                      { staticClass: "transfer-start__card bg--gray" },
                      [
                        _c(
                          "h3",
                          { staticClass: "transfer-start__content-title" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.say.transfer_start_cannot_start_title ||
                                    "Nie możesz wystartować?"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _vm.isFree
                          ? [
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.say.transfer_start_intro_free ||
                                        "Przekaż swój opłacony start innej osobie. Oto jak to działa:"
                                    ) +
                                    " "
                                ),
                              ]),
                              _c(
                                "ul",
                                { staticClass: "transfer-start__steps" },
                                [
                                  _c("li", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.say.transfer_start_step_1 ||
                                            "Podajesz adres e-mail osoby, której chcesz przekazać start."
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("li", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.say.transfer_start_step_2 ||
                                            "Osoba ta otrzymuje e-mail z linkiem do rejestracji oraz informacją o koszcie i terminie ważności przekazania."
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("li", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.say.transfer_start_step_3 ||
                                            "Ty otrzymujesz kod przekazania startu — udostępniasz go zaproszonej osobie (rozliczenie ewentualnego zwrotu opłaty startowej między Wami odbywa się poza systemem)."
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("li", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.say.transfer_start_step_4_free ||
                                            "Zaproszona osoba rejestruje się z linku, wpisuje kod w polu kodu rabatowego i bezpłatnie finalizuje przejęcie startu."
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                              _c("p", { staticClass: "mat16" }, [
                                _c("strong", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.say.transfer_start_free_label ||
                                          "Przekazanie startu jest bezpłatne."
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ]
                          : [
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.say.transfer_start_intro_paid ||
                                        "Możesz przekazać swój opłacony start innej osobie."
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.say.transfer_start_how_it_works ||
                                        "Oto jak to działa:"
                                    ) +
                                    " "
                                ),
                              ]),
                              _c(
                                "ul",
                                { staticClass: "transfer-start__steps" },
                                [
                                  _c("li", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.say.transfer_start_step_1 ||
                                            "Podajesz adres e-mail osoby, której chcesz przekazać start."
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("li", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.say.transfer_start_step_2 ||
                                            "Osoba ta otrzymuje e-mail z linkiem do rejestracji oraz informacją o koszcie i terminie ważności przekazania."
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("li", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.say.transfer_start_step_3 ||
                                            "Ty otrzymujesz kod przekazania startu — udostępniasz go zaproszonej osobie (rozliczenie zwrotu opłaty startowej między Wami odbywa się poza systemem)."
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("li", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.say.transfer_start_step_4_paid ||
                                            "Zaproszona osoba rejestruje się z linku, wpisuje kod w polu kodu rabatowego i opłaca online koszt przekazania."
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                              _c("p", { staticClass: "mat16" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.say.transfer_start_paid_cost_prefix ||
                                        "Koszt przekazania startu:"
                                    ) +
                                    " "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.transferPriceLabel) + " zł"
                                  ),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.say.transfer_start_paid_cost_suffix ||
                                        " (opłaca osoba przejmująca start podczas rejestracji). Ty nie ponosisz dodatkowych kosztów."
                                    ) +
                                    " "
                                ),
                              ]),
                            ],
                        _c("p", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.say.transfer_start_deadline_prefix ||
                                  "Termin: start możesz przekazać najpóźniej do"
                              ) +
                              " " +
                              _vm._s(_vm.deadlineLabel) +
                              ". "
                          ),
                        ]),
                      ],
                      2
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "row transfer-start__section" }, [
                  _c("div", { staticClass: "col-12 col-lg-4" }, [
                    _c(
                      "div",
                      { staticClass: "transfer-start__section-header" },
                      [
                        _c("h3", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.say.transfer_start_email_section_title ||
                                  "Adres e-mail osoby,"
                              ) +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.say
                                  .transfer_start_email_section_description ||
                                  "której przekazujesz swój udział"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "col-12 col-lg-8" }, [
                    _c(
                      "div",
                      { staticClass: "transfer-start__card bg--gray" },
                      [
                        _c("base-input-text", {
                          attrs: {
                            type: "email",
                            label:
                              _vm.say.transfer_start_email_label ||
                              "Adres e-mail odbiorcy",
                            hint:
                              _vm.say.transfer_start_email_hint ||
                              "np. jan@example.com",
                            error: _vm.emailError,
                            "without-error-message": "",
                          },
                          model: {
                            value: _vm.email,
                            callback: function ($$v) {
                              _vm.email = $$v
                            },
                            expression: "email",
                          },
                        }),
                        _vm.emailError
                          ? _c(
                              "p",
                              { staticClass: "transfer-start__error mat8" },
                              [_vm._v(" " + _vm._s(_vm.emailError) + " ")]
                            )
                          : _vm._e(),
                        _vm.submitError
                          ? _c(
                              "p",
                              { staticClass: "transfer-start__error mat8" },
                              [_vm._v(" " + _vm._s(_vm.submitError) + " ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "row transfer-start__section transfer-start__actions",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12 col-lg-4 d-none d-lg-block" },
                      [_vm._v(" ")]
                    ),
                    _c("div", { staticClass: "col-12 col-lg-8" }, [
                      _c(
                        "div",
                        { staticClass: "transfer-start__buttons" },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { btn3: "", short: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.goBack()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.say.transfer_start_btn_back || "Cofnij"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "base-button",
                            {
                              staticStyle: { "min-width": "260px" },
                              attrs: {
                                btn1: "",
                                short: "",
                                loading: _vm.isSubmitting,
                                disabled: _vm.isSubmitting,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.submit()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.say.transfer_start_btn_send || "Wyślij"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row transfer-start__section" }, [
      _c("div", { staticClass: "col-12 col-lg-4" }, [
        _c("div", {
          staticClass:
            "transfer-start__section-header transfer-start__section-header--skeleton",
        }),
      ]),
      _c("div", { staticClass: "col-12 col-lg-8" }, [
        _c("div", {
          staticClass:
            "transfer-start__card bg--gray transfer-start__card--skeleton",
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row transfer-start__section" }, [
      _c("div", { staticClass: "col-12 col-lg-4" }, [
        _c("div", {
          staticClass:
            "transfer-start__section-header transfer-start__section-header--skeleton",
        }),
      ]),
      _c("div", { staticClass: "col-12 col-lg-8" }, [
        _c("div", {
          staticClass:
            "transfer-start__card bg--gray transfer-start__card--skeleton transfer-start__card--short",
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }